import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { Badge, Button, CircularProgress, alpha, useTheme } from "@mui/material";

import { marketplaceTypography as mt } from "../constants/marketplaceTypography";

interface WooOrdersTriggerButtonProps {
  unpaidCount: number;
  onOpenOrders: () => void;
  showLabel?: boolean;
  loading?: boolean;
}

/** Botão Meus pedidos de dispensação — separado do pedido em andamento. */
export function WooOrdersTriggerButton({
  unpaidCount,
  onOpenOrders,
  showLabel = false,
  loading = false,
}: WooOrdersTriggerButtonProps) {
  const theme = useTheme();
  const showCount = unpaidCount > 0;

  const icon = loading ? (
    <CircularProgress size={18} color="inherit" />
  ) : (
    <Badge
      badgeContent={showCount ? unpaidCount : 0}
      color="warning"
      overlap="circular"
      invisible={!showCount}
    >
      <ReceiptLongOutlinedIcon fontSize="small" />
    </Badge>
  );

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={onOpenOrders}
      disabled={loading}
      aria-label={
        loading
          ? "Carregando pedidos"
          : showCount
            ? `Meus pedidos, ${unpaidCount} aguardando pagamento`
            : "Meus pedidos"
      }
      startIcon={icon}
      sx={{
        minHeight: 36,
        px: showLabel ? 1.25 : 1,
        borderColor: alpha(theme.palette.primary800.main, 0.2),
        bgcolor: alpha(theme.palette.primary800.main, 0.04),
        color: "primary800.main",
        ...mt.button,
        textTransform: "none",
        flexShrink: 0,
        "&:hover": {
          bgcolor: alpha(theme.palette.primary800.main, 0.08),
          borderColor: alpha(theme.palette.primary800.main, 0.35),
        },
      }}
    >
      {showLabel ? "Meus pedidos" : null}
    </Button>
  );
}
